import type { ColorRun, StyleRun } from '@rta/rta-blueprint-library';

import { applyStyleRun, normalizeStyleRuns } from './apply-style-run';

/** Anything carrying the two persisted run arrays -- a SkuAnnotation instance or a serialized record */
export type StyleRunSource = {
	colorRuns?: Array<ColorRun>;
	styleRuns?: Array<StyleRun>;
};

/**
 * The runs a renderer should draw: legacy `colorRuns` as the base layer with `styleRuns` merged on top, so
 * designs saved before style runs existed keep their colors. Any WRITE path should persist this result into
 * `styleRuns` and clear `colorRuns` (lazy per-record migration -- no schema version bump).
 */
export const resolveAnnotationStyleRuns = (source: StyleRunSource): Array<StyleRun> => {
	const { colorRuns = [], styleRuns = [] } = source;
	if (colorRuns.length === 0) return normalizeStyleRuns(styleRuns);

	const base = normalizeStyleRuns(colorRuns.map(({ start, end, color }) => ({ start, end, color })));
	return styleRuns.reduce((runs, run) => {
		const { start, end, ...patch } = run;
		return applyStyleRun({ runs, start, end, patch });
	}, base);
};
